import CustomPagination from '@/Component/Common/Tables/CustomPagination';
import MyJobBox from './MyJobBox';

const MyJobListing = (props) => {
    const { data, userDetails, refetch, params, setParams, isPending, setOpenSideModal, translations } = props;
    return (
        <>
            {data?.data?.length > 0 ?
                <>
                    {
                        data?.data?.map((item, index) => (
                            <MyJobBox key={index} data={item} userDetails={userDetails} refetch={refetch} setOpenSideModal={setOpenSideModal} translations={translations} />
                        ))
                    }
                    {data?.total > 12 &&
                        <CustomPagination total={data?.total} currentPageObj={params} setParams={setParams} />}
                </> :
                <>
                    {!isPending && data?.data?.length == 0 &&
                        <div className='w-full bg-lightPrimary p-5 rounded-lg flex items-center justify-center mt-4'>{translations?.noDataFound}</div>
                    }
                </>
            }
        </>
    )
}

export default MyJobListing
